// src/components/TawkTo.jsx

import { useEffect } from "react";

const TawkTo = () => {
  useEffect(() => {
    const script = document.createElement("script");

    script.async = true;
    script.src =
      "https://embed.tawk.to/69f658648523f61c32f24268/1jnl4ij0a";

    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null;
};

export default TawkTo;